export const updateCamera = (ctx) => {
    ctx.getCameraController().update();
};
